import { BasicButton } from "./BasicButton";

export class OpenShopButton extends BasicButton {
  private onOpenShopCallback?: () => void;
  private onCloseShopCallback?: () => void;
  private isShopOpen: boolean = false;

  constructor(
    scene: Phaser.Scene,
    onOpenShopCallback?: () => void,
    onCloseShopCallback?: () => void,
  ) {
    super(
      scene,
      "Open Shop",
      {
        textureKey: "Button1",
      },
      {
        textureKey: "Button2",
      },
      undefined,
      undefined,
    );
    this.background.setTint(0xac4c3f);
    this.onOpenShopCallback = onOpenShopCallback;
    this.onCloseShopCallback = onCloseShopCallback;
  }

  handlePointerDown(): void {
    // Visual feedback handled by parent class
  }

  handlePointerUp(): void {
    if (this.isShopOpen) {
      if (this.onCloseShopCallback) {
        this.onCloseShopCallback();
      }
    } else {
      if (this.onOpenShopCallback) {
        this.onOpenShopCallback();
      }
    }
  }

  public updateShopState(isOpen: boolean): void {
    this.isShopOpen = isOpen;
    this.SetText(isOpen ? "Close Shop" : "Open Shop");
  }

  handlePointerOver(): void {
    // Visual feedback handled by parent class
  }

  handlePointerOut(): void {
    // Visual feedback handled by parent class
  }
}
